export default [
  {
    path: 'phase-2/:id',
    props: true,
    name: 'onBoard.neofintech.phase2',
    children: [
      {
        path: '1',
        name: 'onBoard.neofintech.phase2.1',
        meta: {
          prev: null,
          next: 'onBoard.neofintech.phase2.2',
          name: 'Moneda/divisa',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#00b0f0'
            },
            step: {
              number: 1,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Moneda / Divisa'
            },
            sideHelp: {
              text:  '¿En qué moneda o divisa te interesa el programa de capital?'
            },
            help: {
              text: '¿En qué moneda o divisa te interesa el programa de capital?'
            },
            quote: {
              text: 'Q12T',
              author: 'Q12A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/1.vue'
          )
      },
      {
        path: '2',
        name: 'onBoard.neofintech.phase2.2',
        meta: {
          prev: 'onBoard.neofintech.phase2.1',
          next: 'onBoard.neofintech.phase2.3',
          name: 'Importe solicitado',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#1f497d'
            },
            step: {
              number: 2,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Importe solicitado'
            },
            sideHelp: {
              text:  '¿Cuál es el importe del programa de capital que nos solicitas?'
            },
            help: {
              text: '¿Cuál es el importe del programa de capital que nos solicitas?'
            },
            quote: {
              text: 'Q13T',
              author: 'Q13A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/2.vue'
          )
      },
      {
        path: '3',
        name: 'onBoard.neofintech.phase2.3',
        meta: {
          prev: 'onBoard.neofintech.phase2.2',
          next: 'onBoard.neofintech.phase2.4',
          name: 'Ventas último año',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#9dea36'
            },
            step: {
              number: 3,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Ventas último año'
            },
            sideHelp: {
              text:  '¿Qué ventas tuvo la empresa en el último año fiscal cerrado?'
            },
            help: {
              text: '¿Qué ventas tuvo la empresa en el último año fiscal cerrado?'
            },
            quote: {
              text: 'Q14T',
              author: 'Q14A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/3.vue'
          )
      },
      {
        path: '4',
        name: 'onBoard.neofintech.phase2.4',
        meta: {
          prev: 'onBoard.neofintech.phase2.3',
          next: 'onBoard.neofintech.phase2.5',
          name: 'EBITDA',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#ffc000'
            },
            step: {
              number: 4,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'ebidtaSign'
            },
            sideHelp: {
              text: '¿Que EBIDTA tuvo el último cierre fiscal en vigor?'
            },
            help: {
              text: '¿Que EBIDTA tuvo el último cierre fiscal en vigor?'
            },
            quote: {
              text: 'Q15T',
              author: 'Q15A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/4.vue'
          )
      },
      {
        path: '5',
        name: 'onBoard.neofintech.phase2.5',
        meta: {
          prev: 'onBoard.neofintech.phase2.4',
          next: 'onBoard.neofintech.phase2.6',
          name: 'Balance EBIDTA',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#ff3300'
            },
            step: {
              number: 5,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Balance EBIDTA'
            },
            sideHelp: {
              text:  'Indique el EBIDTA corporativo obtenido por su negocio'
            },
            help: {
              text: 'Indique el EBIDTA corporativo obtenido por su negocio'
            },
            quote: {
              text: 'Q16T',
              author: 'Q16A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/5.vue'
          )
      },
      {
        path: '6',
        name: 'onBoard.neofintech.phase2.6',
        meta: {
          prev: 'onBoard.neofintech.phase2.5',
          next: 'onBoard.neofintech.phase2.7',
          name: 'Previsión de ventas',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#00cc99'
            },
            step: {
              number: 6,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Previsión de ventas'
            },
            sideHelp: {
              text:  '¿Qué ventas están previstas para este año?'
            },
            help: {
              text: '¿Qué ventas están previstas para este año?'
            },
            quote: {
              text: 'Q17T',
              author: 'Q17A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/6.vue'
          )
      },
      {
        path: '7',
        name: 'onBoard.neofintech.phase2.7',
        meta: {
          prev: 'onBoard.neofintech.phase2.6',
          next: 'onBoard.neofintech.phase2.8',
          name: 'Auditor de cuentas',
          hasBottomBar: true,
          showNext: true,
          hasSidebox: true,

          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#cb1a07'
            },
            step: {
              number: 7,
              text: 'Deslizar, elegir y cliquear',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Auditor de cuentas'
            },
            sideHelp: {
              text:  '¿Tiene un auditor de cuentas contratado en la actualidad?'
            },
            help: {
              text: '¿Tiene un auditor de cuentas contratado en la actualidad?'
            },
            quote: {
              text: 'Q18T',
              author: 'Q18A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/7.vue'
          )
      },
      {
        path: '8',
        name: 'onBoard.neofintech.phase2.8',
        meta: {
          prev: 'onBoard.neofintech.phase2.7',
          next: null,
          name: ' ',
          hasBottomBar: true,
          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#00b0f0'
            },
            step: {
              number: 8,
              text: 'Resumen',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Resumen'
            },
            quote: {
              text: 'Q19T',
              author: 'Q19A'
            }
          }
        },

        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/8.vue'
          )
      },
      {
        path: 'status',
        props: true,
        name: 'onBoard.neofintech.phase2.status',
        meta: {
          prev: null,
          next: null,
          name: 'Estado',
          hasBottomBar: false,
          extra: {
            colors: {
              primary: '#5baa35',
              dark: '#376620',
              helpModal: '#00b0f0'
            },
            step: {
              number: 9,
              text: 'Estado',
              icon: 'hand_click'
            },
            wheel: {
              text: 'Estado'
            },
            quote: {
              text: 'Q20T',
              author: 'Q20A'
            }
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/neofintech/phase-2/status.vue'
          )
      }
    ],
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/phase-2/Phase2.vue'
      )
  }
]
